// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3IGL7","title":"AfterFrontImage_title__2j8Bx"};